import React, { Component } from 'react'
import Header from '../../components/header/Header'
import StagesManager from '../../components/StagesManager'
import { chooseFontColor, translate } from '../../utils/useful'
import BaseAdminView from './BaseAdminView'
import SelectApplet from '../../components/useful/SelectApplet'
import Rooms from '../Rooms'
import HttpServices from '../../utils/Http.services'
import { framesConfig } from '../../variables/framesStatics'
import NewSelectApplet from '../../components/useful/NewSelectApplet'
import DashboardView from '../../components/views/DashboardView'
import HeaderDrivePortal from '../../components/header/HeaderDrivePortal'
import HeaderPortal from '../../components/header/HeaderPortal'
import PortalScopeSelector from '../../components/header/PortalScopeSelector'

export default class RoomsPortal extends Component {
    toolbarView = () => {
        return (
            <NewSelectApplet ref={el => { this.roomsToolbar = el }}
                colors={this.props.colors}
                changePage={this.changePage}
                applets={this.state.applets}
                applet={this.state.applet}
                type={'Rooms'}
                setData={this.setCurrentApplet}
                functionsHandler={this.functionsHandler}
                setApplets={this.setApplets}
                // setDataMain={this.setData}
                currentAppletName={this.state.currentAppletName}
                currentApplet={this.state.currentApplet}
                changeFrame={this.changeFrame}
                driveSections={this.state.driveSections}
            />
        )
    }
    state = {
        colors: {
            primaryColor: '#5856d6',
            secondaryColor: '#7c7aff',
            textColor: '#fff'
        },
        headerConfig: {
            showToolbar: true, showSettings: false, showSettings: false, showFrames: true, isPortal: true, title: '{{lang}}Rooms', type: 'drive', 'toolbar': this.toolbarView,
        },
        applets: [],
        frames: [],
        modules: [],
        currentApplet: '',
        currentAppletName: ''

    }
    componentDidMount() {
        this.init(() => {
            this.checkDefaultTab()
        })
    }
    componentDidUpdate(prevProps) {
        if (JSON.stringify(this.props.windowData?.path) != JSON.stringify(prevProps.windowData?.path)) {
            this.checkDefaultTab()
        }
    }
    checkDefaultTab = () => {
        let pathname = this.props.windowData.path//window.location.pathname.split('/')

        let appletId = pathname[this.props.baseUrl.length]
        let applet = this.state.applets.find(element => String(element?._id) == String(appletId))
        // console.log('appletIdc', applet, this.state.applets)
        let frameId = pathname[this.props.baseUrl.length + 1]
        let frame = this.state.frames.find(element => String(element?._id) == String(frameId))

        this.setState({ oldData: this.props.windowData }, () => {
            setTimeout(() => {
                this.setState({ pageStatus: 200 }, () => {
                    if (frameId) {
                        this.filterFrames(appletId, () => {
                            this.setState({ page: frame, applet }, () => {
                                // this.stageManager.changeStage('rooms')

                            })
                        })
                    } else if (appletId) {
                        this.setState({ applet }, () => {
                            this.filterFrames(appletId, () => {
                                // if (this.stageManager) {
                                //     this.stageManager.changeStage('dashboard')
                                // }
                            })
                        })
                    } else {
                        this.setState({ applet }, () => {
                            this.filterFrames(appletId, () => {
                                // this.stageManager.changeStage('dashboard')

                            })
                        })
                    }

                })
            }, 10);

        })

    }






    headerIdentityComponent = () => {

        // let portalImage = '/assets/icons/portals/chat (2).png'
        let portalName = translate("Rooms Portal")
        return (
            <div className='flexc' >
                <button className='flexc' onClick={() => this.changePage()} >
                    <p className=' text-semibig text-semibold' style={{ whiteSpace: "nowrap", color: '#fff' }} >{portalName}</p>
                </button>

                <div className="mx-2  flexc">

                    <PortalScopeSelector type='rooms' language={this.props.language} width={this.props.width} userPerspective={this.props.userPerspective} sections={this.props.sections} modules={this.props.modules} changePage={this.props.changePage} functionsHandler={this.functionsHandler} colors={this.state.colors} frames={this.props.frames} variables={this.props.variables} updateFrames={this.props.updateFrames} />

                    {/* <SelectApplet_ ref={el => this.selectApplet = el} type='messenger' setData={this.setCurrentApplet} language={this.props.settings?.language} colors={this.props.colors} /> */}
                </div>

            </div>
        )
    }





    filterFrames = (id, cb) => {
        if (id) {

            let frameList = JSON.parse(JSON.stringify(this.state.frames))
            // console.log('frameList', frameList)
            frameList = frameList.filter((frame) => String(frame.applet) == String(id))
            // console.log('framesList', frameList)
            this.setState({ modules: frameList }, () => {
                if (cb)
                    cb()
            })
        } else {
            this.setState({ modules: this.state.frames }, () => {
                if (cb)
                    cb()
            })

        }
    }
    setApplets = (applets, cb) => {
        this.setState({ applets }, () => {
            if (cb) {
                cb()
            }
        })
    }
    init = (cb) => {
        let data = {}
        data.type = 'rooms'
        HttpServices.request('getMyAppletFrames', data, (fetchResult, fetchError) => {

            if (fetchError) {
                return
            }
            let applets = fetchResult.applets
            let frames = fetchResult.frames
            let defaultFrame
            let found
            frames.forEach(element => {
                if (element.applet == applets[0]._id && !found) {
                    defaultFrame = element
                    found = true
                }
                let frameInfo
                // console.log('element0000',element)
                if (element.mode) {
                    frameInfo = framesConfig[element.mode]
                }
                if (!frameInfo) {
                    frameInfo = framesConfig[element.type]
                }

                if (frameInfo) {
                    Object.entries(frameInfo)?.map(([key, value]) => {
                        element[key] = value
                        if (typeof value == 'string' && value.startsWith('{{')) {
                            let baseValue = value.replace(/{/g, '').replace(/}/g, '')
                            element[key] = element[baseValue]
                        }
                    })
                }

            })

            this.setState({ applets, frames }, () => {

                // if (!this.props.windowData.path[this.props.baseUrl.length]) {
                //     this.setState({ applet: applets[0] }, () => {
                //         this.changePage(defaultFrame._id)
                //     })
                // } else if (!this.props.windowData.path[this.props.baseUrl.length + 1]) {
                //     let frame
                //     frames.map((element) => {
                //         if (element.applet == this.props.windowData.path[this.props.baseUrl.length] && !frame) {

                //             frame = element
                //         }
                //     })
                //     console.log('foundFrameId', frame._id)
                //     this.setState({ page: frame }, () => {
                //         this.changePage(frame._id)
                //     })
                // }
                // console.log('applets, frames', this.state.applets, this.state.frames)
                if (cb) {
                    cb()
                }
            })
        })

    }





    changePage = (page, info) => {

        // console.log("changePage", page)
        let extraPath = Array.isArray(page) ? page : [page]
        let fullPath = [...this.props.baseUrl, ...extraPath]
        this.changeWindow(fullPath, info)

    }


    changeWindow = (list, info) => {

        if (Array.isArray(list)) {
            let finalList = []
            list.forEach(value => {
                let one = value
                if (/\{\{(.*?)\}\}/.test(value)) {
                    if (this.props.variables) {
                        one = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                    }
                }
                if (one) {
                    finalList.push(one)
                }
            });

            // console.log(finalList)

            let data = { type: 'applet', path: finalList }
            if (info) {
                data.params = info
            }

            // console.log(data)

            this.props.changeWindow('applet', data)
        }
    }





    // functionsHandler = (type, name, data, extra) => {
    //     if (this[name]) {
    //         this[name](data, extra)
    //     }
    // }

    // changeFrame = () => {

    // }

    functionsHandler = (type, name, data, info) => {


        // console.log(type, name, data, info)
        if (type) {
            if (type == 'admin') {
                this[name](data, info)
            } else {
                if (this[type] && this[type][name]) {
                    this[type][name](data)
                }
            }
        } else {
            if (this[name]) {
                this[name](data, info)
            }
        }
    }




    changeScope = (data) => {
        this.setState({ currentScope: data })
    }





    setCurrentApplet = (key, value, cb) => {
        this.setState({ [key]: value }, () => {
            if (cb) {
                cb()
            }
        })
    }
    setHeader = (key, value) => {
        if (this.header) {
            if (typeof key == 'object') {
                let object = {
                    showSettings: false,
                    headerIdentityComponent: this.headerIdentityComponent
                }
                if (this.props.defaultHeaderConfig) {
                    object = { ...this.props.defaultHeaderConfig }
                }
                for (const [okey, ovalue] of Object.entries(key)) {
                    object[okey] = ovalue
                }
                if (object.showSettings && this.props.showSettings) {
                    object.showSettings = this.props.showSettings
                }
                this.setState({ headerConfig: object }, () => {
                    this.header.forceUpdate()
                })
            }
            else {
                this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
                    this.header.forceUpdate()
                })
            }
        }
    }
    setData = () => {

    }
    render() {
        // let variables = {
        //     applet: this.props.applet._id,
        //     appletHub: this.props.applet.hub
        // }
        let variables = this.props.variables

        let colors = this.state.colors ?? {}
        let applet = this.state.applet

        if (applet?.colorType == 'sameAsHub') {
            if (this.props.user.info?.colors) {
                colors = this.props.user.info.colors
            }
        }

        if (applet?.colorType == "custom" && applet?.colors) {
            colors = applet?.colors
        }

        if (!colors?.textColor) {
            colors.textColor = '#fff'
        }

        let iconInvert = chooseFontColor(colors.textColor) == '#fff' ? true : false

        colors.iconInvert = iconInvert
        colors.background = `linear-gradient(90deg, ${colors.primaryColor}, ${colors.secondaryColor})`
        // console.log('variables', variables)
        // console.log('this.psstaet', this.state.applet)
        return (
            <div className="bg-white w-100 d-flex flex-column window-content-radius h-100" style={{ backgroundColor: '#F5F5F5' }}  >
                <div style={{ position: 'relative', top: 0 }}>
                    {/* {console.log('this.state.modules', this.state.modules)} */}
                    {/* <Header ref={el => this.header = el} config={this.state.headerConfig} setCurrentApplet={this.setCurrentApplet} frames={this.state.modules} appletType={this.props.type} isPortal={true} toolbar={this.state.toolbar} showToolbar={this.state.showToolbar} type={'static'} functionsHandler={this.functionsHandler} page={this.state.page} language={this.props.language} isDesktop={this.props.isDesktop} toolbarView={'applet'} headertype={'applet'} headers={this.state.headers} goToHub={this.props.goToHub} backStage={this.backStage} sections={this.state.sections} modules={this.state.modules} changePage={this.changePage} backbtn={this.state.showBackBtn} applet={this.state.applet} width={this.props.width} colors={colors} features={this.props.applet?.features} setHeader={this.setHeader} backActionMobile={this.backActionMobile} /> */}
                    <HeaderPortal ref={el => this.header = el} config={this.state.headerConfig} currentHub={this.state.currentHub} currentApplet={this.state.currentApplet} currentFrame={this.state.currentFrame} isPortal={true} changeNav={this.changeNav} setCurrentApplet={this.setCurrentApplet} frames={this.state.modules} appletType={this.props.type} toolbar={this.state.toolbar} showToolbar={this.state.showToolbar} type={'static'} functionsHandler={this.functionsHandler} page={this.state.page} language={this.props.language} isDesktop={this.props.isDesktop} toolbarView={'applet'} headertype={'applet'} headers={this.state.headers} goToHub={this.props.goToHub} backStage={this.backStage} sections={this.state.sections} modules={this.state.modules} changePage={this.changePage} backbtn={this.state.showBackBtn} applet={this.state.applet} width={this.props.width} colors={colors} features={this.props.applet?.features} setHeader={this.setHeader} backActionMobile={this.backActionMobile} portalImage={'/assets/icons/portals/video-calling (1).png'} portalName={translate("Rooms Portal")} />

                </div>
                {/* <StagesManager height={'0px'} className={'flex-1'} ref={el => this.stageManager = el} fast={true} > */}
                {/* <DashboardView stage={1} stageName={'dashboard'} permissionLevel={this.props.permissionLevel} permissions={this.props.permissions} language={this.props.language} setData={this.setData} setHeader={this.setHeader} onClick={this.changePage} applet={this.state.applet} pages={this.state.pages} width={this.props.width} height={this.props.height} user={this.props.user} modules={this.state.modules} changePage={this.changePage} title={"Manage"} description={"Manage things and applets"} baseUrl={this.props.baseUrl} variables={this.state.variables} isPortal={true} defaultHeaderConfig={this.state.headerConfig}/> */}
                <div className='flex-1' style={{ height: 0 }}>
                    <Rooms stage={0} stageName={'rooms'} isDesktop={this.props.isDesktop} page={this.state.page} applet={this.state.applet} scope={this.state.currentScope} toolbarView={this.toolbarView} isMobile={this.props.isMobile} permissions={this.props.permissions} baseUrl={[...this.props.baseUrl]} frames={this.state.frames} framesSections={this.state.framesSections} colors={colors} language={this.props.language} functionsHandler={this.functionsHandler} width={this.props.width} height={this.props.height} lastSelected={this.props.lastSelected} variables={this.props.variables} windowData={this.props.windowData} route={this.props.route} changeWindowLink={this.props.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.props.goToHub} setHeader={this.setHeader} changePage={this.changePage} />
                </div>
                {/* </StagesManager> */}

            </div>
        )
    }
}
